import styles from "./style.module.scss";
import { h } from "preact";
import { Text } from "preact-i18n";
import PlusIcon from "icons/PlusIcon";
import Area from "components/Area/Area";
import Button from "components/Button/Button";
import type MvAdressResult from "models/MvAddressResult";
import type MvInputParams from "models/MvInputParams";
import type { CountryCode } from "models/CountryCode";
import type DefaultOptions from "models/DefaultOptions";
import type { LoadingActions } from "components/StoreContextWrapper/actions";
import { SDKState } from "services/sdkState";

export interface MainContentProps extends LoadingActions {
    apiBasePath?: string;
    state: SDKState;
    onAddArea(): void;
    onSelectArea(id: string): void;
    onRemoveArea(id: string): void;
    onAddressChange(id: string, address: MvAdressResult | null): void;
    onUpdateParams(id: string, patch: Partial<MvInputParams>): void;
    onAddressesFound(id: string, addresses: MvAdressResult[]): void;
    onShowAddresses(): void;
    countryCode?: CountryCode;
    isLoading: boolean;
    defaultOptions: DefaultOptions;
}

const MainContent = ({
    state,
    onAddArea,
    onSelectArea,
    onRemoveArea,
    onAddressChange,
    onUpdateParams,
    onAddressesFound,
    onShowAddresses,
    ...props
}: MainContentProps) => {
    const { areas, activeAreaId, pricePerAddress } = state;
    return (
        <div className={styles.mvWrapper}>
            <h1 className={styles.mvTitle}>
                <Text id="general.labels.areas">Areas</Text>
            </h1>
            {areas.map((area) => (
                <Area
                    key={area.id}
                    {...props}
                    pricePerAddress={pricePerAddress}
                    addressData={area}
                    isDisabled={area.disabled}
                    isSelected={area.id === activeAreaId}
                    onChange={onAddressChange}
                    onUpdateParams={onUpdateParams}
                    onRemove={(area) => onRemoveArea(area.id)}
                    onSelect={onSelectArea}
                    onAddressesFound={onAddressesFound}
                    onShowAddresses={onShowAddresses}
                />
            ))}
            <Button
                type="primary"
                className={styles.mvAddAreaButton}
                outline
                disabled={props.isLoading}
                onClick={onAddArea}
            >
                <PlusIcon className={styles.mvPlusIcon} fill="currentColor" />
                <Text id="general.buttons.addArea">Add area</Text>
            </Button>
        </div>
    );
};
export default MainContent;
